<template>
  <div>
    <a-empty
      v-if="currentDeptId == ''"
      :description="$t('msg.I_K0002002_01')"
      style="margin: calc(10% - 32px) 0px 10%"
    />

    <div v-else style="padding: 21px 24px">
      <!-- 検索区域 -->
      <div class="table-page-search-wrapper">
        <!-- 搜索区域 -->
        <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
          <a-row :gutter="24">
            <a-col :sm="24" :md="8" :lg="8" :xl="10" :xxl="6">
              <a-form-model-item label="" style="margin-bottom: 17px">
                <a-input
                  :placeholder="$t('disp.ph.matchOr', ['员工编号', '员工姓名'])"
                  v-model="queryParam.username"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :xs="1" :sm="1" class="width-fit-content">
              <a-form-model-item :wrapperCol="{ span: 24 }">
                <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                  $t('disp.btn.search')
                }}</a-button>
                <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <!-- ボタン操作区域 -->
      <div class="table-operator" :md="24" :sm="24" v-if="!executeDisabled && !changePlanId">
        <a-button @click="$refs.SelectEmployee.visible = true" type="primary" icon="plus">{{
          $t('disp.btn.add')
        }}</a-button>
        <a-button @click="batchDel" icon="close" v-if="selectedRowKeys.length > 0">{{
          $t('disp.user.batch.delete.btn')
        }}</a-button>
      </div>

      <!-- table区域-begin -->
      <template>
        <div class="ant-alert ant-alert-info div-selected-info">
          <i class="anticon anticon-info-circle ant-alert-icon"></i>
          {{ this.$t('disp.selected') }}
          <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
          {{ this.$t('disp.item') }}
          <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>

          <div style="float: right">
            <span style="margin-right: 8px">包含下级组织</span>
            <a-switch
              size="small"
              v-model="queryParam.includeChildren"
              style="position: relative; top: -1px"
              @change="searchQuery(false, false)"
            />
          </div>
        </div>

        <a-table
          ref="table"
          :class="!executeDisabled && !changePlanId ? 'action' : ''"
          tableLayout="auto"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          @change="handleTableChange"
          :rowSelection="
            !executeDisabled && !changePlanId ? { selectedRowKeys: selectedRowKeys, onChange: onSelectChange } : null
          "
        >
          <!--<a-table-column key="index" title="#" :width="47" align="center">
            <template slot-scope="text, record, index">
              {{ (ipagination.current - 1) * ipagination.pageSize + parseInt(index) + 1 }}
            </template>
          </a-table-column>-->

          <a-table-column key="username" data-index="username" title="员工编号" />

          <a-table-column key="realname" data-index="realname" title="姓名">
            <div slot-scope="text, record" style="font-size: 14px; white-space: nowrap">
              <div style="width: 26px; display: inline-block; margin-right: 10px">
                <a-tag color="blue" style="min-width: unset; transform: scale(0.9)" v-if="record.sex == 1"
                  ><span class="mdi mdi-gender-male"></span
                ></a-tag>
                <a-tag color="pink" style="min-width: unset; transform: scale(0.9)" v-if="record.sex == 2"
                  ><span class="mdi mdi-gender-female"></span
                ></a-tag>
              </div>

              <span>{{ record.realname }}</span>
            </div>
          </a-table-column>

          <a-table-column key="workAddr" data-index="workAddr" title="工作地点" align="left" />

          <a-table-column key="relations" data-index="relations" align="left">
            <span slot="title">
              <span>所属信息</span>
              <!--<br />
              <span class="note">（点击标签可编辑）</span>-->
            </span>
            <template slot-scope="text, record">
              <div v-for="row in record.relations" :key="row.id">
                <div class="relation-wrapper">
                  <a-tag
                    color="pink"
                    class="ant-tag-pink"
                    v-if="row.departId == currentDeptId && queryParam.includeChildren"
                    >{{ row.departName }}</a-tag
                  >
                  <a-tag color="blue" v-else>{{ row.departName }}</a-tag>
                  <a-tag color="green" v-if="row.positionName">{{ row.positionName }}</a-tag>
                  <a-tag color="orange" v-if="row.bizLineName">{{ row.bizLineName }}</a-tag>
                </div>
              </div>
            </template>
          </a-table-column>

          <a-table-column key="postLevel" data-index="postLevel" title="职级" :width="60" align="center">
            <template slot-scope="text, record">
              <a-tag color="purple" v-if="record.postLevel">{{ record.postLevel }}</a-tag>
            </template>
          </a-table-column>

          <a-table-column key="delFlag" data-index="delFlag" title="状态" :width="90" align="center">
            <template slot-scope="text, record">
              <!-- 系统用户 -->
              <a-tag color="blue" v-if="record.delFlag == '0' && !record.employeeType && !record.entryDay"
                >系统用户</a-tag
              >
              <!-- 离职 -->
              <a-tag v-else-if="record.delFlag == '1' && record.retirementDay">离职</a-tag>
              <!-- 削除 -->
              <a-tag v-else-if="record.delFlag == '1' && !record.retirementDay">删除</a-tag>
              <!-- 等待入职 -->
              <a-tag color="orange" v-else-if="record.delFlag == '-1'">等待入职</a-tag>
              <!-- 即将离职 -->
              <a-tag
                color="red"
                v-else-if="
                  record.delFlag == '0' &&
                  record.retirementDay &&
                  moment(record.retirementDay).isAfter(moment(new Date()))
                "
                >即将离职</a-tag
              >
              <!-- 试用期 -->
              <a-tag color="cyan" v-else-if="!record.regularFlag">试用期</a-tag>
              <!-- 在职 -->
              <a-tag color="green" v-else>在职</a-tag>
            </template>
          </a-table-column>

          <a-table-column key="action" title="操作" v-if="!executeDisabled && !changePlanId" align="center">
            <div slot-scope="text, record" style="white-space: nowrap">
              <a @click="$refs.EditRelation.handleOpen(record)">编辑所属</a>

              <a-divider type="vertical" />
              <a-popconfirm
                placement="topRight"
                :title="$t('msg.confirm.remove')"
                @confirm="() => handleDelete(record)"
              >
                <a>{{ $t('disp.btn.remove') }}</a>
              </a-popconfirm>
            </div>
          </a-table-column>
        </a-table>
      </template>
      <!-- table区域-end -->

      <!-- フォーム区域 -->
      <SelectEmployee
        ref="SelectEmployee"
        @emit="emitFromSelectEmployee"
        :params="{
          isMulti: true,
          excludeDepartId: currentDeptId,
          parent: 'DepartUserInfo',
        }"
      ></SelectEmployee>

      <EditRelation ref="EditRelation" @emit="searchQuery(true, false)"></EditRelation>
    </div>
  </div>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { getAction, postAction, deleteAction, putAction } from '@/api/manage'
import SelectEmployee from '@/views/k01/k0101/SelectEmployee'
import EditRelation from '@/views/k00/k0002/modules/EditRelation'

export default {
  name: 'DepartUserInfo',
  mixins: [tableMixin],
  components: {
    SelectEmployee,
    EditRelation,
  },
  props: {
    // 组织变更计划ID
    changePlanId: {
      type: String,
      default: '',
    },
    // 是否可以编辑
    executeDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      description: this.$t('disp.userInfo'),
      disableMixinSearchQuery: true,
      currentDeptId: '',
      parentId: '',
      queryParam: {
        username: '',
        includeChildren: false,
        departId: '',
        parentId: '',
        changePlanId: '',
      },
      url: {},
    }
  },
  mounted() {},
  methods: {
    searchReset() {
      this.queryParam.username = ''
      this.$forceUpdate()
    },
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error(this.$t('disp.setUrlDeleteBatch'))
        return
      }

      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t('disp.rules.select'))
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectionRows.length; a++) {
          ids += this.selectionRows[a].id + ','
        }
        var that = this
        console.log(this.currentDeptId)
        this.$confirm({
          title: this.$t('disp.warn'),
          content: this.$t('msg.confirm.removeBatch'),
          onOk: function () {
            postAction(that.url.deleteBatch, { ids: ids, changePlanId: that.changePlanId }).then((res) => {
              if (res.success) {
                that.$message.success(that.$t('msg.remove.success'))
                that.searchQuery(true, false)
                that.onClearSelected()
              }
            })
          },
        })
      }
    },
    handleDelete: function (record) {
      if (!this.url.delete) {
        this.$message.error(this.$t('disp.setUrlDelete'))
        return
      }

      var that = this
      postAction(that.url.delete, { id: record.id, changePlanId: that.changePlanId }).then((res) => {
        if (res.success) {
          that.$message.success(that.$t('msg.remove.success'))
          if (this.selectedRowKeys.length > 0) {
            for (let i = 0; i < this.selectedRowKeys.length; i++) {
              if (this.selectedRowKeys[i] == id) {
                this.selectedRowKeys.splice(i, 1)
                break
              }
            }
          }
          that.searchQuery(true, false)
        }
      })
    },
    open(record) {
      this.currentDeptId = record.id
      this.parentId = record.parentId
      this.queryParam.departId = this.currentDeptId
      this.queryParam.parentId = this.parentId
      this.queryParam.changePlanId = this.changePlanId

      if (this.changePlanId) {
        this.url = {
          list: '/blaze-sys/k00/k0015/DepartAction/departUserList',
          add: '/blaze-sys/k00/k0015/DepartAction/addUserToDepart',
          delete: '/blaze-sys/k00/k0015/DepartAction/deleteUserInDepart',
          deleteBatch: '/blaze-sys/k00/k0015/DepartAction/deleteUserInDepartBatch',
        }
      } else {
        this.url = {
          list: '/blaze-sys/k00/k0014/UserManage/departUserList',
          add: '/blaze-sys/k00/k0014/UserManage/addUserToDepart',
          delete: '/blaze-sys/k00/k0014/UserManage/deleteUserInDepart',
          deleteBatch: '/blaze-sys/k00/k0014/UserManage/deleteUserInDepartBatch',
        }
      }

      this.searchQuery(false, false)
    },
    clearList() {
      this.currentDeptId = ''
      this.dataSource = []
    },
    emitFromSelectEmployee(data) {
      let params = {}
      params.departId = this.currentDeptId
      params.changePlanId = this.changePlanId
      params.userIdList = []
      for (var i = 0; i < data.length; i++) {
        params.userIdList.push(data[i].id)
      }
      postAction(this.url.add, params).then((res) => {
        if (res.success) {
          this.$message.success(this.$t(res.message))
          this.searchQuery(false, false)
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.ant-card {
  margin-left: -10px;
}

.table-page-search-wrapper {
  margin-top: -16px;
  margin-bottom: 0px;
}

:global(.ant-select) {
  :global(.ant-select-selection) {
    background-color: transparent;
    border: none;
    cursor: pointer;
    box-shadow: none;
    min-height: unset;

    :global(input.ant-select-search__field) {
      width: 0px;
    }

    :global(.ant-select-selection__rendered) {
      margin-left: 0px;
      margin-bottom: -2px;
    }
  }
}

.ant-select.loading /deep/ .ant-select-selection__choice__disabled {
  padding: 0 20px 0 5px;
}

/deep/ .ant-select-selection__placeholder {
  margin-left: 0;
}
</style>
